import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import {
  LoadSmartCleanRecordsFail,
  LoadSmartCleanRecordsSuccess,
  PatchCleanScoreFail,
  PatchCleanScoreSuccess
} from 'src/app/features/qa-testing/clean-score/redux/clean-score.actions';
import { QACleanScoreItem } from 'src/app/models/qa-models/smart-clean';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';
@Injectable({ providedIn: 'any' })
export class SmartCleanService {
  public smart_clean_api = APIS.SMART_CLEAN_PMAP;
  public smart_clean_api_p2map = APIS.SMART_CLEAN_P2MAP;
  public util = new UtilityService();

  constructor(
    private store: Store,
    private apiService: AmplifyApiService
  ) {}

  public loadSmartCleanRecordsAmplify(robotId: string) {
    this.apiService
      .get(this.smart_clean_api, `/${ENVIRONMENT.apiHkcApiName}/qa/list?robot_id=${robotId}`, {})
      .then((response) => {
        if ('regions' in response) {
          this.store.dispatch(new LoadSmartCleanRecordsSuccess(response));
        } else {
          this.store.dispatch(new LoadSmartCleanRecordsFail(`No Maps found for ${robotId}`));
        }
      })
      .catch((error) => {
        this.store.dispatch(new LoadSmartCleanRecordsFail(error));
        console.error(error);
      });
  }

  public patchCleanScoreAmplify(body: QACleanScoreItem) {
    return this.apiService
      .patch(this.smart_clean_api, `/${ENVIRONMENT.apiHkcApiName}/qa/modify`, { body })
      .then(() => {
        this.store.dispatch(new PatchCleanScoreSuccess());
      })
      .catch((error) => {
        console.error(error);
        const message = this.util.convertErrorToMessage(error);
        this.store.dispatch(new PatchCleanScoreFail(message));
      });
  }

  public patchCleanScoreP2mapAmplify(body: QACleanScoreItem) {
    return this.apiService
      .patch(this.smart_clean_api_p2map, `/${ENVIRONMENT.apiHkcApiName}/qa/modify`, { body })
      .then(() => {
        this.store.dispatch(new PatchCleanScoreSuccess());
      })
      .catch((error) => {
        console.error(error);
        const message = this.util.convertErrorToMessage(error);
        this.store.dispatch(new PatchCleanScoreFail(message));
      });
  }
}
